module.exports = __webpack_public_path__ + "img/vps7.7a3a735.png";